export default __webpack_public_path__ + "static/media/skip_selected.bcedf2e3.svg";